
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SettingsService } from 'src/app/settings/settings.service';;

declare var $: any;


@Component({
    selector: 'app-alert-delete',
    templateUrl: './alert-delete.html',
    styleUrls: ['./alert-delete.less'],
    standalone: false
})
export class AlertDelete implements OnInit {



  @Input() onboarding:boolean=false;

  //cuando estemos en el onboarding, si onboarding es true, el dialogo que se va a mostrar en ambos casos de descarte
  //es decir accion sea 2 o 3
  //vamos a mostrar un unico mensaje que permitira al cliente continuar con el onboarding y quedaria en la misma pantalla de editar simulacion
  //pero no dejameros que elimine todas las facturas, siempre debe haber una factura independiente el valor que sea.

  constructor(private change:ChangeDetectorRef,public dialog: MatDialog, public dialogRef:MatDialogRef<AlertDelete>,private snackBar:MatSnackBar,public settings: SettingsService,private router:Router) {



   }

  id_factura:any;
  id_sim:any;
  accion:any;
  deletefacturas:boolean=false;


  ngOnInit() {


  }

  close(){
    this.dialogRef.close(true)
  }

  title:string="¡Estás a punto de descartar el archivo!";
  subtitle:string="Si lo haces, será borrado de la documentación agregada.";
  titledelete:string="¡Estás a punto de eliminar tu única factura!";
  show_succes:boolean=false;
  loading_delete:boolean=false;
  async delete_factura(){
    this.loading_delete = true;

    try {
      
      const bd: any = await this.settings.get_query(4, '/cliente/simulacion-documentos/'+this.id_factura+'/?accion='+this.accion, );
      var body_data: any =bd._body;
      var data = body_data.success;
      switch (bd.status) {
        case 200:

        if(this.accion == 1){
          this.titledelete = "¡Factura eliminada!"
          this.title = "Tu operación tuvo que ser descartada.";
          this.subtitle ="Para iniciar una nueva, vuelve a simular";
          this.show_succes = true;


        }else if(this.accion == 2){
          if(this.onboarding == true){
            this.titledelete = "¡Factura eliminada!"
            this.title = "Agrega una factura de un monto <strong>igual o mayor</strong> a la que eliminaste para";
            this.subtitle ="reajustar la simulación o continúa con tu incorporación como cliente.";
            this.show_succes = true;
          } else {
            this.titledelete = "¡Factura eliminada!"
            this.title = "Tu operación tuvo que ser descartada.";
            this.subtitle ="Para iniciar una nueva, vuelve a simular";
            this.show_succes = true;
          }
          
        }else{
          this.snackBar.open('Factura eliminada correctamente', 'Aceptar', {
            duration: 20000,
            panelClass: 'simpli-snack'
          });
          this.dialogRef.close(true)
        }

        this.loading_delete = false;



        break;
        default:

        break;
      }

    } catch (bd:any) {

      this.loading_delete = false;

      switch (bd.status) {
        case 500:

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
          break;

        case 400: 

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
          break;
        default:

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });

        break;
      }
    }
  }

  volver_simular(){
    this.dialogRef.close()
    this.router.navigate(['/home/']);

    setTimeout(() => {
      if( $('#caja_excel').length )      
      {
        $("#caja_excel").trigger('click');
      }
    });
  }

  agregar_factura_onboarding(){
    this.dialogRef.close('agregar_factura');
  }

  continuar_incorporacion(){
    this.dialogRef.close('continuar_incorporacion');
  }

}
